module.exports = __webpack_public_path__ + "img/print-circle.a8fb4fdc.svg";